export default __webpack_public_path__ + "static/img/delivery.7933d91.png";